/*Generated from the `:::slide{key="7f80f739-fafd-4856-bfc2-c79525d8ee0c" slug="level-2/han"}` (simplified/002/002.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, SlideTitle, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!SlideTitle) _missingMdxReference("SlideTitle", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.blockquote) _missingMdxReference("html.blockquote", true);
  if (!html.li) _missingMdxReference("html.li", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.ul) _missingMdxReference("html.ul", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "SlideTitle",
      count: "5",
      children: _jsx(SlideTitle, {
        children: "Introducing Han",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "5",
      children: _jsx(html.p, {
        children: "Some mnemonics are more memorable with concrete subjects, even if they don't contribute to the meaning of the character itself.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "5",
      children: _jsx(html.p, {
        children: "You'll encounter the following people",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "0",
      kind: "ul",
      count: "5",
      children: _jsxs(html.ul, {
        children: [_jsx(html.li, {
          children: "Han (a guy)",
          components: html
        }), _jsx(html.li, {
          children: "Hannah (a girl)",
          components: html
        }), _jsx(html.li, {
          children: "Hansel (a kid)",
          components: html
        })]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "4",
      section: "0",
      kind: "blockquote",
      count: "5",
      children: _jsx(html.blockquote, {
        children: _jsx(html.p, {
          children: "Fun fact: Han is the name of the majority ethnic group in China and Taiwan.",
          components: html
        }),
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
